import BlogPost from '~/components/Blog/BlogPostMeasurements'

export default function BlogMeasurementsPage() {
  return <BlogPost />
}